import { WeeklyTrainingRouteProvider } from "contexts/WeeklyTrainingRoutesContext"
import { WeeklyTrainingEcardsContext } from "contexts/WeeklyTrainingEcardsContext"
import { WeeklyTrainings } from "pages/trainings/WeeklyTrainings"
import { SpecificTraining } from "pages/trainings/SpecificTraining"

const BASE = "/vivint-ads/weekly-trainings"

export const VivintWeeklyTrainings = () => (
  <WeeklyTrainingEcardsContext.Provider value={true}>
    <WeeklyTrainingRouteProvider basePath={BASE}>
      <WeeklyTrainings />
    </WeeklyTrainingRouteProvider>
  </WeeklyTrainingEcardsContext.Provider>
)

export const VivintSpecificTraining = () => (
  <WeeklyTrainingEcardsContext.Provider value={true}>
    <WeeklyTrainingRouteProvider basePath={BASE}>
      <SpecificTraining />
    </WeeklyTrainingRouteProvider>
  </WeeklyTrainingEcardsContext.Provider>
)
